//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import { VueTelInput } from 'vue-tel-input'
import { mapGetters } from 'vuex'
import veeValidate from '~/mixins/veeValidate'
import VueToastMixin from '~/mixins/plugins/vue-toastification'
import GTM from '~/utils/classes/Gtm'

export default {
  name: 'ContactUsForm',
  components: { VueTelInput },
  mixins: [veeValidate, VueToastMixin],
  data () {
    return {
      form: new Form({
        name: '',
        email: '',
        phone: '',
        message: '',
        numberFormat: '',
        currentCountry: '',
        preferredCountries: ''
      }),
      formRules: {
        name: 'required',
        email: 'required|email',
        phone: 'phone',
        message: 'required'
      },
      isBusy: false,
      phoneValid: true,
      failed: false,
      success: false,
      gtm: new GTM(this.$gtm)
    }
  },
  computed: {
    ...mapGetters({
      countryCodes: 'data/countryCodes',
      ipInfo: 'ip'
    })
  },
  methods: {
    async sendContact () {
      this.isBusy = true

      if (!this.phoneValid) {
        this.isBusy = false
        this.$refs.formObs.setErrors({ phone: ['Field is not valid'] })
        return
      }

      const isValid = await this.$refs.formObs.validate()
      if (!isValid) {
        this.isBusy = false
        return
      }
      const token = await window.grecaptcha.enterprise.execute('6LergzosAAAAANRiH17D_j0qby18iQk2R5L2gjW7', {action: 'CONTACTS'}) //this.$recaptcha.getResponse()

      const data = this.form.data()

      if (this.ipInfo?.ip) {
        data.message += `; Customer IP: ${this.ipInfo.ip}`
      }

      this.$store.dispatch('contact/sendContact', { ...data, gRecaptchaResponse: token })
        .then(() => {
          this.success = true
          this.failed = false
          this.contact = {}
          this.form.reset()
          this.$toast.success(this.$t('your-message-has-been-sen'))

          this.gtm.contact_us_form(Object.filter(data, (d) => d !== ''))
        })
        .catch(() => {
          this.success = false
          this.failed = true
          this.$toast.error(this.$t('something-went-wrong-ple'))
        })
        .finally(() => {
          this.isBusy = false
        })
    }
  }
}
